<div class="acr-dialog">

	<!-- Header -->
	<div mat-dialog-title class="acr-header d-flex align-items-center justify-content-between">
		<div class="d-flex align-items-center">
			<mat-icon class="acr-header-icon mr-2">calculate</mat-icon>
			<div>
				<div class="acr-header-title">Re-evaluate Avg Cost</div>
				<div class="acr-header-sub text-muted small">{{ data.stockid }}<ng-container *ngIf="data.description"> — {{ data.description }}</ng-container></div>
			</div>
		</div>
		<button mat-icon-button (click)="close()" matTooltip="Close" class="acr-close-btn">
			<mat-icon>close</mat-icon>
		</button>
	</div>

	<mat-dialog-content class="acr-content">

		<!-- Loading -->
		<div class="text-center py-4" *ngIf="loading">
			<mat-spinner diameter="44"></mat-spinner>
			<p class="mt-2 text-muted small mb-0">Loading stock movements…</p>
		</div>

		<!-- Error -->
		<div class="alert alert-danger d-flex align-items-center py-2" *ngIf="errorMsg && !loading">
			<mat-icon class="mr-2 flex-shrink-0">error_outline</mat-icon>
			<span class="small">{{ errorMsg }}</span>
		</div>

		<!-- Movements table -->
		<ng-container *ngIf="!loading && !errorMsg && steps.length">

			<div class="d-flex align-items-center justify-content-between mb-2">
				<span class="small text-muted">{{ steps.length }} movement(s) · weighted average recalculation</span>
				<span class="small text-muted acr-progress-hint">
					{{ visibleSteps.length }} / {{ steps.length }}
				</span>
			</div>

			<div class="table-responsive acr-table-wrap">
				<table class="table table-sm acr-table mb-0">
					<thead>
						<tr>
							<th>#</th>
							<th>Date</th>
							<th>Reference</th>
							<th class="text-right">Qty</th>
							<th class="text-right">Price</th>
							<th class="text-right">Prev QOH</th>
							<th class="text-right">New QOH</th>
							<th class="text-right">Running Avg</th>
						</tr>
					</thead>
					<tbody>
						<tr *ngFor="let s of visibleSteps"
							[ngClass]="{ 'acr-row-done': s.done, 'acr-row-pending': !s.done }">
							<td class="small text-muted">{{ s.seq }}</td>
							<td class="small">{{ s.trandate }}</td>
							<td class="small text-muted">{{ s.reference }}</td>
							<td class="small text-right">{{ s.qty }}</td>
							<td class="small text-right">{{ s.price | currency }}</td>
							<td class="small text-right text-muted">{{ s.prevqty }}</td>
							<td class="small text-right">{{ s.newqoh }}</td>
							<td class="small text-right font-weight-bold acr-avg-col">{{ s.runningAvg | currency:'USD':'symbol':'1.4-4' }}</td>
						</tr>
					</tbody>
				</table>
			</div>

		</ng-container>

		<!-- No movements -->
		<div class="text-center py-4 text-muted small" *ngIf="!loading && !errorMsg && !steps.length">
			No type-25 stock movements found for this item.
		</div>

		<!-- Result box -->
		<ng-container *ngIf="!loading && calculatedCost !== null">
			<div class="acr-result-box mt-3 d-flex align-items-center justify-content-between flex-wrap">
				<div>
					<div class="small text-muted mb-1">Current avg cost</div>
					<div class="acr-cost-value text-muted">{{ data.currentCost | currency:'USD':'symbol':'1.4-4' }}</div>
				</div>
				<mat-icon class="text-muted mx-3">arrow_forward</mat-icon>
				<div>
					<div class="small text-muted mb-1">Calculated avg cost</div>
					<div class="acr-cost-value font-weight-bold text-dark">{{ calculatedCost | currency:'USD':'symbol':'1.4-4' }}</div>
				</div>
				<div *ngIf="applied" class="ml-auto">
					<span class="badge badge-success acr-applied-badge">
						<mat-icon style="font-size:14px;width:14px;height:14px;vertical-align:middle;">check_circle</mat-icon>
						Applied
					</span>
				</div>
			</div>
		</ng-container>

	</mat-dialog-content>

	<mat-dialog-actions class="acr-actions d-flex justify-content-end px-3 py-2">
		<button mat-stroked-button type="button" (click)="close()">
			{{ applied ? 'Close' : 'Cancel' }}
		</button>
		<button mat-stroked-button type="button" (click)="recalculate()" [disabled]="loading || applying" class="ml-2">
			<mat-icon>refresh</mat-icon>
			Recalculate
		</button>
		<button
			mat-raised-button
			color="primary"
			type="button"
			class="ml-2"
			[disabled]="loading || applying || applied || calculatedCost === null"
			(click)="apply()">
			<mat-spinner *ngIf="applying" diameter="16" class="d-inline-block mr-1"></mat-spinner>
			<mat-icon *ngIf="!applying">save</mat-icon>
			{{ applying ? 'Applying…' : 'Apply Cost' }}
		</button>
	</mat-dialog-actions>

</div>
